import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default {
    name     : "swiper",
    _selector: "[data-swiper]",
    _swipers : [],
    init() {
        this._swipers = document.querySelectorAll(this._selector);

        if (!this._swipers) {
            return;
        }

        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

        let slides = 3;
        if (vw < 500) {
            slides = 1;
        } else if (vw < 1280) {
            slides = 2;
        }
            
        for (const container of this._swipers) {
            const swiper = new Swiper(container, {
                loop: true,
                spaceBetween: 30,
                slidesPerView: slides,
                pagination: {
                    el: ".swiper-pagination",
                    type: "fraction",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        }
    }
};